import { defineStore } from 'pinia'
import { ref } from 'vue'
import { API_CONFIG } from '@/api/config.js';
import i18n from '@/plugins/i18n';

export const useUsuarioStore = defineStore(
    'usuario',
    () => {
        const dadosUsuario = ref({
            id: null, // <-- Adicione a propriedade ID aqui
            user_company_id: null, 
            nome: '',
            sobrenome: '',
            email: '',
            avatar: '',
            idioma: 'pt-BR',
            cpf: '',
            phone: ''
        })

        function setLocale(novoIdioma) {

            const idiomaValido = novoIdioma || 'pt-BR';

            dadosUsuario.value.idioma = idiomaValido;

            const idiomaCurto = idiomaValido.substring(0, 2);
            i18n.global.locale.value = idiomaCurto;
            document.querySelector('html').setAttribute('lang', idiomaCurto);

        }
        function definirDadosUsuario(dados) {

            const idiomaFinal = dados.system_language || dadosUsuario.value.idioma || 'pt-BR';

            dadosUsuario.value = {
                ...dadosUsuario.value,
                nome: dados.first_name,
                sobrenome: dados.last_name,
                email: dados.email,
                avatar: dados.avatar ? API_CONFIG.baseUrl + dados.avatar : null,
                idioma: idiomaFinal,
                phone: dados.phone,
                id: dados.id, // <-- ADICIONE ESTA LINHA PARA GUARDAR O ID DO USUÁRIO
                user_company_id: dados.user_company_id,
            };

            setLocale(idiomaFinal);
        }

        function getLang() {
            return dadosUsuario.value.idioma;
        }

        function atualizarPerfil(dados) {

            try {
                const novoEstado = {
                    nome: dados.user_name,
                    sobrenome: dados.last_name || '',
                    email: dados.user_email,
                    idioma: dados.user_sys_lang || 'pt-BR',
                    cpf: dados.user_identifier,
                    phone: dados.user_phone,
                    avatar: getAvatar()
                };

                dadosUsuario.value = novoEstado;


                setLocale(dados.user_sys_lang);

            } catch (error) {
                console.error('%c[Store] ERRO CRÍTICO dentro da action "atualizarPerfil":', 'color: red; font-weight: bold;', error);
            }
        }


        function limparDadosUsuario() {
            dadosUsuario.value = {
                ...dadosUsuario.value,
                nome: '',
                sobrenome: '',
                email: '',
                avatar: '',
                cpf: '',
                phone: ''
            };
        }

        function getAvatar() {
            return dadosUsuario.value.avatar;
        }

        function removeAvatar() {
            dadosUsuario.value.avatar = null;
        }

        function definirAvatar(avatar) {
            dadosUsuario.value.avatar = avatar ? API_CONFIG.baseUrl + avatar : null;
        }

        return {
            dadosUsuario,
            getAvatar,
            getLang,
            removeAvatar,
            atualizarPerfil,
            definirDadosUsuario,
            limparDadosUsuario,
            definirAvatar,
            setLocale
        }
    },
    {
        persist: {
            key: 'usuario-store',
            paths: ['dadosUsuario'],
        },
    }
)
